import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCampaignStatisticsDataQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCampaignStatisticsDataQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly name: string, readonly mediaplanType?: Types.AccountsCompanyMediaplanType | null, readonly campaignMediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperCampaignMediaplanStat', readonly campaignId: string, readonly campaignName: string, readonly accountId: string, readonly accountName: string, readonly mediaplanType: string, readonly spent: number, readonly clicks: number, readonly impressions: number, readonly conversions: number, readonly ePurchaseConversions: number, readonly revenue: number }> } | null } | null };

export type GetCampaignStatisticsAnalyticsSettingsQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCampaignStatisticsAnalyticsSettingsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly kpiSettings: { readonly __typename?: 'YalperKpiSettings', readonly attributionModel?: Types.YalperAnalyticAttributionModelEnum | null, readonly goals: ReadonlyArray<number>, readonly revenueGoalId?: number | null }, readonly analyticGoals: ReadonlyArray<{ readonly __typename?: 'YalperAnalyticGoal', readonly id: number, readonly isEcomm: boolean, readonly name: string, readonly counterId: number, readonly counterName: string }> } | null } | null };


export const GetCampaignStatisticsDataDocument = gql`
    query GetCampaignStatisticsData($companyId: ID, $startDate: Date!, $endDate: Date!) {
  currentUser {
    company(id: $companyId) {
      name
      mediaplanType
      campaignMediaplanStats(startDate: $startDate, endDate: $endDate) {
        campaignId
        campaignName
        accountId
        accountName
        mediaplanType
        spent
        clicks
        impressions
        conversions
        ePurchaseConversions
        revenue
      }
    }
  }
}
    `;

/**
 * __useGetCampaignStatisticsDataQuery__
 *
 * To run a query within a React component, call `useGetCampaignStatisticsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStatisticsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStatisticsDataQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCampaignStatisticsDataQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables> & ({ variables: GetCampaignStatisticsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables>(GetCampaignStatisticsDataDocument, options);
      }
export function useGetCampaignStatisticsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables>(GetCampaignStatisticsDataDocument, options);
        }
export function useGetCampaignStatisticsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables>(GetCampaignStatisticsDataDocument, options);
        }
export type GetCampaignStatisticsDataQueryHookResult = ReturnType<typeof useGetCampaignStatisticsDataQuery>;
export type GetCampaignStatisticsDataLazyQueryHookResult = ReturnType<typeof useGetCampaignStatisticsDataLazyQuery>;
export type GetCampaignStatisticsDataSuspenseQueryHookResult = ReturnType<typeof useGetCampaignStatisticsDataSuspenseQuery>;
export type GetCampaignStatisticsDataQueryResult = Apollo.QueryResult<GetCampaignStatisticsDataQueryPage, GetCampaignStatisticsDataQueryVariables>;
export const GetCampaignStatisticsAnalyticsSettingsDocument = gql`
    query GetCampaignStatisticsAnalyticsSettings($companyId: ID) {
  currentUser {
    company(id: $companyId) {
      kpiSettings {
        attributionModel
        goals
        revenueGoalId
      }
      analyticGoals(companyId: $companyId) {
        id
        isEcomm
        name
        counterId
        counterName
      }
    }
  }
}
    `;

/**
 * __useGetCampaignStatisticsAnalyticsSettingsQuery__
 *
 * To run a query within a React component, call `useGetCampaignStatisticsAnalyticsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStatisticsAnalyticsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStatisticsAnalyticsSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCampaignStatisticsAnalyticsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>(GetCampaignStatisticsAnalyticsSettingsDocument, options);
      }
export function useGetCampaignStatisticsAnalyticsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>(GetCampaignStatisticsAnalyticsSettingsDocument, options);
        }
export function useGetCampaignStatisticsAnalyticsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>(GetCampaignStatisticsAnalyticsSettingsDocument, options);
        }
export type GetCampaignStatisticsAnalyticsSettingsQueryHookResult = ReturnType<typeof useGetCampaignStatisticsAnalyticsSettingsQuery>;
export type GetCampaignStatisticsAnalyticsSettingsLazyQueryHookResult = ReturnType<typeof useGetCampaignStatisticsAnalyticsSettingsLazyQuery>;
export type GetCampaignStatisticsAnalyticsSettingsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignStatisticsAnalyticsSettingsSuspenseQuery>;
export type GetCampaignStatisticsAnalyticsSettingsQueryResult = Apollo.QueryResult<GetCampaignStatisticsAnalyticsSettingsQueryPage, GetCampaignStatisticsAnalyticsSettingsQueryVariables>;